"use strict";

import React from "react";
import { Col, Form, Button } from "react-bootstrap";

import OrganizationSearch from "../../Organization-Search";

class SchoolForm extends React.Component {
  constructor() {
    super();

    this.state = {
      org: null,
      orgUrl: "",
      degree: "",
      grade: "",
      major: "",
      attended: {
        start: "",
        end: "",
        isCurrent: false
      },
      description: ""
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleChangeYear = this._handleChangeYear.bind(this);
    this._handleDateChange = this._handleDateChange.bind(this);
    this._handleCurrentChange = this._handleCurrentChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleCancel = this._handleCancel.bind(this);
    this._handleOrganizationChange = this._handleOrganizationChange.bind(this);
    this._handleOrganizationSelection = this._handleOrganizationSelection.bind(this);
    this._handleOrganizationBlur = this._handleOrganizationBlur.bind(this);
  }

  static propTypes = {
    school: React.PropTypes.object,
    onSubmit: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired
  };

  componentWillMount() {
    const { school } = this.props;
    if (school) {
      this.setState({
        org: school.org || school.orgWithoutUrl,
        grade: school.grade,
        major: school.major,
        degree: school.degree,
        attended: {
          start:
            school.attended && school.attended.start
              ? new Date(school.attended.start).getFullYear()
              : "",
          end:
            school.attended && school.attended.end
              ? new Date(school.attended.end).getFullYear()
              : "",
          isCurrent: school.attended.isCurrent
        },
        description: school.description
      });
    }
  }

  render() {
    const { org, grade, degree, major, attended, description } = this.state;
    console.log("this.state ->", this.state);
    return (
      <div>
        <div className="form-group">
          <label>Name</label>
          <OrganizationSearch
            value={org}
            onSelection={this._handleOrganizationSelection}
            onChange={this._handleOrganizationChange}
            onBlur={this._handleOrganizationBlur}
          />
        </div>
        <div className="form-group">
          <label>Degree</label>
          <input
            type="text"
            className="form-control"
            value={degree}
            placeholder="Enter Degree..."
            onChange={this._handleInputChange.bind(this, "degree")}
          />
        </div>
        <div className="form-group">
          <label>Major</label>
          <input
            type="text"
            className="form-control"
            value={major}
            placeholder="Enter Major..."
            onChange={this._handleInputChange.bind(this, "major")}
          />
        </div>
        <div className="form-group">
          <label>Grade</label>
          <input
            type="text"
            className="form-control"
            value={grade}
            placeholder="Enter Grade..."
            onChange={this._handleInputChange.bind(this, "grade")}
          />
        </div>
        <div className="form-group">
          <h4>Attended</h4>
          <div className="row">
            <Col md={6}>
              <div>
                <label>Start</label>
                <input
                  type="text"
                  className="form-control"
                  maxLength="4"
                  placeholder="Year"
                  //onKeyPress={ this._handleChangeYear }
                  value={attended.start}
                  onChange={this._handleDateChange.bind(this, "start")}
                />
              </div>
            </Col>
            <Col md={6}>
              {!attended.isCurrent ? (
                <div>
                  <label>End</label>
                  <input
                    type="text"
                    className="form-control"
                    maxLength="4"
                    placeholder="Year"
                    //onKeyPress={ this._handleChangeYear }
                    value={attended.end}
                    onChange={this._handleDateChange.bind(this, "end")}
                  />
                </div>
              ) : null}
            </Col>
          </div>
        </div>
        <div className="form-group checkbox">
          <label>
            <input
              type="checkbox"
              checked={attended.isCurrent}
              onChange={this._handleCurrentChange}
            />{" "}
            Currently studying here.
          </label>
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={this._handleInputChange.bind(this, "description")}
          />
        </div>
        <div className="form-group">
          <Button
            bsStyle="success"
            type="submit"
            onClick={this._handleSubmit}
          >
            Save
          </Button>
          <Button bsStyle="default" onClick={this._handleCancel}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    this.setState({ [formInput]: value });
  }

  _handleOrganizationSelection(value) {
    this.setState({
      org: {
        _id: value._id,
        name: value.name || value._source.name,
        logoUrl: value.logoUrl || value._source.logoUrl
      }
    });
  }

  _handleOrganizationChange(value) {
    this.setState({ org: value });
  }

  _handleOrganizationBlur() {
    if (typeof this.state.org === "string") {
      this.setState({ isCustomOrg: true }, () => {
        // this.orgUrl.focus();
      });
    }
    if (typeof this.state.org === "object") {
      this.setState({ isCustomOrg: false, orgUrl: "" });
    }
  }

  _handleChangeYear(e) {
    const regXp = /[0-9]+/g;
    if (!regXp.test(e.key)) e.preventDefault();
  }

  _handleDateChange(type, e) {
    let value = e.target.value;
    if (isNaN(value)) {
      value = "";
    } else {
      value = parseInt(value, 10);
    }
    // this.setState(state => {
    //   state.attended[type] = value;
    // });
    this.setState({ attended: { ...this.state.attended, [type]: value } });
  }

  _handleCurrentChange(e) {
    const value = e.target.checked;
    this.setState({ attended: { ...this.state.attended, end: "", isCurrent: value} });
    // this.setState(state => {
    //   state.attended.end = "";
    //   state.attended.isCurrent = value;
    // });
  }

  _handleSubmit(e) {
    e.preventDefault();
    const { org, degree, major, grade, attended, description } = this.state;

    this.props.onSubmit({
      org: org,
      degree: degree,
      major: major,
      grade: grade,
      attended: {
        start: (attended.start && new Date(attended.start, 0)) || undefined,
        end: (attended.end && new Date(attended.end, 0)) || undefined,
        isCurrent: attended.isCurrent
      },
      description: description
    });
  }

  _handleCancel() {
    this.props.onCancel();
  }
}

export default SchoolForm;
